export function getAuthToken () {
  return localStorage.getItem('jwt')
}

export function storeAuthToken (token) {
  localStorage.setItem('jwt', token)
}

export function removeAuthToken () {
  localStorage.removeItem('jwt')
  if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem('jwt')
}
